import React from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { Button, Header, Icon, Segment, Table } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import EnergyType from './EnergyType'

const Energy: React.FC = () => {
  const { t } = useTranslation()
  const { control } = useFormContext()

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'energyTypes'
  })

  return (
    <>
      <Table celled>
        <col style={{ width: '50%' }} />
        <col style={{ width: '20%' }} />
        <col style={{ width: '20%' }} />
        <col style={{ width: '10%' }} />
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>{t('Energy Type')}</Table.HeaderCell>
            <Table.HeaderCell>{t('Amount')}</Table.HeaderCell>
            <Table.HeaderCell>{t('Unit')}</Table.HeaderCell>
            <Table.HeaderCell>{t('Actions')}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {fields.map((field, index) => (
            <EnergyType
              key={field.id}
              id={field.id}
              removeEnergyType={remove}
              energyIndex={index}
           />
          ))}
        </Table.Body>
      </Table>
      <div style={{ display: 'flex', justifyContent: 'end' }}>
        <Button
          type='button'
          icon='plus'
          style={{ color: 'white' }}
          content={t('Add Energy Type')}
          onClick={() => append({
            id: null,
            amount: null,
            amountUnit: null
          })}
      />
      </div>
    </>
  )
}

export default Energy
